import {useAuth0} from '@auth0/auth0-react';
import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import {useCheckPermissions} from './auth/index.js';
import {ProtectedRoute} from './components/index.js';
import Layout from './layouts/Layout.js';
import {
  Home,
  Streams,
  Patients,
  PatientNew,
  PatientUpdate,
  PatientProfile,
  PatientLogs,
  Codes,
  Routers,
  Cameras,
  Nvrs,
  AiUsageDashboard,
  MediaStatusDashboard,
} from './pages/index.js';
import Login from './pages/Login.js';
import Logs from './pages/Logs.js';
import Monitor from './pages/Monitors/Monitor.js';
import Monitors from './pages/Monitors/Monitors.js';

const AppRoutes = () => {
  const {isAuthenticated} = useAuth0();
  const {
    canReadFeed,
    canReadPatient,
    canCreatePatient,
    canUpdatePatient,
    canReadLog,
    canManageCamera,
    canManageRouter,
    canReadCode,
    canManageUsers,
    canReadActivityEvent,
  } = useCheckPermissions();
  return (
    <Routes>
      {isAuthenticated
        ?
        <Route path="/" element={<Layout/>}>
          <Route index element={<Home/>}/>
          {/*  Streams  */}
          <Route
            path="streams"
            element={
              <ProtectedRoute
                component={Streams}
                allowedPermission={canReadFeed && canReadPatient}
              />
            }
          />

          {/*   Patients   */}
          <Route
            path="patients"
            element={<ProtectedRoute component={Patients} allowedPermission={canReadPatient}/>}
          />
          <Route
            path="patients/new"
            element={<ProtectedRoute component={PatientNew} allowedPermission={canCreatePatient}/>}
          />
          <Route
            path="patients/:patientId"
            element={<ProtectedRoute component={PatientProfile} allowedPermission={canReadPatient}/>}
          />
          <Route
            path="patients/:patientId/update"
            element={<ProtectedRoute component={PatientUpdate} allowedPermission={canUpdatePatient}/>}
          />
          <Route
            path="patients/:patientId/logs"
            element={
              <ProtectedRoute
                component={PatientLogs}
                allowedPermission={canReadLog && canReadPatient}
              />
            }
          />

          {/* Cameras */}
          <Route
            path="cameras"
            element={<ProtectedRoute component={Cameras} allowedPermission={canManageCamera}/>}
          />

          {/* Routers */}

          <Route
            path="routers"
            element={<ProtectedRoute component={Routers} allowedPermission={canManageRouter}/>}
          />

          {/* NVRs */}
          <Route
            path="nvrs"
            element={<ProtectedRoute component={Nvrs} allowedPermission={canManageCamera}/>}
          />

          {/* Media status */}
          <Route
            path="media-status"
            element={<ProtectedRoute component={MediaStatusDashboard} allowedPermission={canManageCamera}/>}
          />

          {/* Codes */}

          <Route path="codes"
                 element={<ProtectedRoute component={Codes} allowedPermission={canReadCode}/>}/>

          {/* Logs */}
          <Route
            path="logs"
            element={
              <ProtectedRoute
                component={Logs}
                allowedPermission={canReadLog && canReadPatient}
              />
            }
          />

          {/* AI usage */}
          <Route
            path="ai-usage"
            element={
              <ProtectedRoute component={AiUsageDashboard} allowedPermission={canReadActivityEvent} />
            }
          />
          <Route
            path={'monitors'}
            element={
              <ProtectedRoute
                component={Monitors}
                allowedPermission={canManageUsers}
              />}
          />
          <Route
            path="monitors/:id"
            element={<ProtectedRoute component={Monitor} allowedPermission={canManageUsers}/>}
          />
        </Route>
        : <Route path={'/'} element={<Login/>}/>
      }
      <Route path={'*'} element={<Navigate to={'/'}/>}/>
    </Routes>
  );
};

export default AppRoutes;
